import { LoadMoreObserver, Typography, TypographyVariant } from "@onmo/ui";
import { useStyles } from "./ProfileActivity.style";
import map from "lodash-es/map";
import ActivityCard from "../ActivityCard/ActivityCard";
import { RecentActivitiesLoading } from "../RecentActivitiesLoading";
import { useActivities } from "../../../hooks/useActivities";
import { FC, HTMLAttributes } from "react";
import { User } from "@onmo/graphql/graphql";
import { Activities } from "../../../models/activities";
import { useTranslation } from "react-i18next";

interface IProfileActivity extends HTMLAttributes<HTMLDivElement> {
  me?: User;
}

const ProfileActivity: FC<IProfileActivity> = ({ me }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { activitiesByDate, loadMoreActivity, loading } = useActivities();
  const isEmpty = Object.keys(activitiesByDate).length === 0;

  return (
    <div className={classes.profileActivity}>
      <Typography variant={TypographyVariant.BodyB2Bold}>
        {t("recent_activity")}
      </Typography>
      {loading || !me ? (
        <RecentActivitiesLoading />
      ) : isEmpty ? (
        <Typography variant={TypographyVariant.BodyB5Regular}>
          {t("no_activity_yet")}
        </Typography>
      ) : (
        map(activitiesByDate, (list, date) => {
          return (
            <div key={date}>
              <Typography
                variant={TypographyVariant.BodyB6Regular}
                className={classes.title}
              >
                {date}
              </Typography>
              {map(list, (activity, idx) => {
                return <ActivityCard activity={activity} key={idx} />;
              })}
            </div>
          );
        })
      )}
      <LoadMoreObserver loadMore={loadMoreActivity} />
    </div>
  );
};

export default ProfileActivity;
